import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

/** Redirects retained bookmarks for the retired shipment editor to read-only view mode. */
@Injectable({ providedIn: 'root' })
export class ShipmentEditDisabledGuard implements CanActivate {
    constructor(private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): UrlTree {
        return this.router.createUrlTree(['/shipment/view', route.paramMap.get('shipmentId')], {
            queryParams: { editingDisabled: 'true' }
        });
    }
}
